export default __webpack_public_path__ + "static/media/black-x-background.2dc78dcc.svg";